import { useSelector, useDispatch } from 'react-redux';
import { closeAuth } from '../redux/slices/authUiSlice';
import LoginForm from '../layouts/dashboard/header/visitor/LoginForm';
import Register from '../layouts/dashboard/header/visitor/Register';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Balance from '../views/user/Balance';
import ResetPasswordDialog from '../layouts/dashboard/header/forgotpassword/ResetPasswordDialog';

const AuthDialogContainer = () => {
  const dispatch = useDispatch();
  const { open, view } = useSelector((state) => state.authUi);

  if (!open) return null;

  const handleClose = () => dispatch(closeAuth());

  switch (view) {
    case 'register':
      return <Register handleOpen={open} handleClose={handleClose} />;

    case 'forgot':
      return <ForgotPassword handleOpen={open} handleClose={handleClose} />;

    case 'balance':
      return <Balance handleOpen={open} handleClose={handleClose} />;

    case 'reset':
      return <ResetPasswordDialog handleOpen={open} handleClose={handleClose} />;

    default:
      return <LoginForm handleOpen={open} handleClose={handleClose} />;
  }
};

export default AuthDialogContainer;
